<template>
  <!-- <v-flex
    v-if="this.component.enable.download"
    xs6
    sm2
    md2
    class="d-inline"
  > -->
  <div v-if="this.component.enable.download" class="d-inline">
    <v-tooltip bottom>
      <v-btn
        slot="activator"
        @click.native="component.name != 'NFSE'? setPositionMenu($event) : downloadMulti('xml')"
        class="bg_white"
      >
        <svg class="customIcon i_header" viewBox="0 0 24 24">
          <path
            fill="#000000"
            d="M14,2L20,8V20A2,2 0 0,1 18,22H6A2,2 0 0,1 4,20V4A2,2 0 0,1 6,2H14M18,20V9H13V4H6V20H18M12,19L8,15H10.5V12H13.5V15H16L12,19Z"
          />
        </svg>
        <small>Download</small>
      </v-btn>
      <span>{{component.name == 'NFSE' ? 'Baixar XML das notas selecionada':'Baixar PDF e/ou XML das notas selecionada'}}</span>
    </v-tooltip>

    <v-menu
      v-model="menu"
      nudge-top="20"
      :position-x="menuX"
      :position-y="menuY"
      :close-on-content-click="true"
      bottom
      offset-y
    >
      <v-list id="options">
        <div id="title">Opções de download</div>

        <v-list-tile class="item" v-for="(item, index) in items" :key="index">
          <v-list-tile-title @click="downloadMulti(item.evento)">
            <v-tooltip right>
              <div slot="activator" class="text-xs-center">
                <v-icon style="font-size: 15px;">{{item.icon}}</v-icon>
                {{ item.title }}
              </div>

              <span>{{item.tooltip}}</span>
            </v-tooltip>
          </v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
    </div>
  <!-- </v-flex> -->
</template>
<script>
export default {
  props: ["component", "arraySelect", "empresa", "table", "conta"],
  data: () => ({
    menu: false,
    menuX: 0,
    menuY: 0,
    items: [
      {
        title: "XML",
        tooltip: "Baixar apenas XML das notas selecionadas",
        icon: "",
        evento: "xml"
      },
      {
        title: "PDF",
        tooltip: "Baixar apenas PDF das notas selecionadas",
        icon: "",
        evento: "pdf"
      },
      {
        title: "XML e PDF",
        tooltip: "Baixar XML e PDF das notas selecionadas",
        icon: "",
        evento: "xml-pdf"
      }
    ]
  }),
  methods: {
    setPositionMenu: function(e) {
      this.menuX = e.clientX + 15;
      this.menuY = e.clientY + 20;
      this.menu = !this.menu;
    },
    downloadMulti: async function(evento) {
      let idNota = [];
      if (this.arraySelect.length > 0) {
        await this.arraySelect.forEach(function(item) {
          if (item) {
            idNota.push(item._id);
          }
        });
        let notas = { notas: idNota, acao: evento };
        this.setDownload(notas);
      } else {
        this.table.snackAlert();
        this.table.snack.text = "Necessário escolher ao menos uma nota";
        this.table.snack.show = true;
      }
    },
    setDownload: function(notas) {
      //debugger;
      let url = this.$http.options.root;
      switch (this.component.name) {
        case "CTE":
          url += "ctes/download/multi";
          break;
        case "NFeRecebidas":
          url += "nfes/download/multi";
          break;
        case "NFSE":
          url += "nfses/download/multi";
          break;
        default:
          throw new Error("Não foi possísvel setar url para buscar zip");
      }
      var xhr = new XMLHttpRequest();
      xhr.open("POST", url, true);
      xhr.setRequestHeader("Content-type", "application/json");
      this.activeGlobalLoader();
      var fileName = `${this.component.abrev}-${notas.acao}.zip`;
      let auxRmvGlobalLoader = this.desactiveGlobalLoader;
      xhr.onreadystatechange = function() {
        if (xhr.readyState == 4 && xhr.status == 200) {
          var blob = new Blob([xhr.response], {
            type: "application/zip"
          });
          if (navigator.msSaveOrOpenBlob) {
            navigator.msSaveOrOpenBlob(blob, fileName);
          } else {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display:none";
            var url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = fileName;
            a.click();
            window.URL.revokeObjectURL(url);
            a.remove();
            auxRmvGlobalLoader();
          }
        } else {
          auxRmvGlobalLoader();
        }
      };

      xhr.responseType = "arraybuffer";
      xhr.send(JSON.stringify(notas));

      // APÓS SEPARAÇÃO EM MICROSERVIÇOS DEVERÁ FICAR ASSIM
      // APÓS SEPARAÇÃO EM MICROSERVIÇOS DEVERÁ FICAR ASSIM
      // APÓS SEPARAÇÃO EM MICROSERVIÇOS DEVERÁ FICAR ASSIM
      // let url = this.$http.options.root;
      // switch (this.component.name) {
      //   case "CTE":
      //     url += "ctes/download/multi";
      //     break;
      //   case "NFeRecebidas":
      //     url += "nfes/download/multi";
      //     break;
      //   case "NFSE":
      //     url += "nfses/download/multi";
      //     break;
      //   default:
      //     throw new Error("Não foi possísvel setar url para buscar zip");
      // }
      // url = 'http://localhost:3050/util/gerarZip'
      // var xhr = new XMLHttpRequest();
      // xhr.open("POST", url, true);
      // xhr.setRequestHeader("Content-type", "application/json");
      // xhr.setRequestHeader("Authorization", Vue.http.headers.common['Authorization']);
      // this.activeGlobalLoader();
      // var fileName = `${this.component.abrev}-${notas.acao}.zip`;
      // let auxRmvGlobalLoader = this.desactiveGlobalLoader;
      // xhr.onreadystatechange = function() {
      //   if (xhr.readyState == 4 && xhr.status == 200) {
      //     var blob = new Blob([new Uint8Array(xhr.response.zip.data)], {
      //       type: "application/zip"
      //     });
      //     if (navigator.msSaveOrOpenBlob) {
      //       navigator.msSaveOrOpenBlob(blob, fileName);
      //     } else {
      //       var a = document.createElement("a");
      //       document.body.appendChild(a);
      //       a.style = "display:none";
      //       var url = window.URL.createObjectURL(blob);
      //       a.href = url;
      //       a.download = fileName;
      //       a.click();
      //       window.URL.revokeObjectURL(url);
      //       a.remove();
      //       auxRmvGlobalLoader();
      //     }
      //   } else {
      //     auxRmvGlobalLoader();
      //   }
      // };

      // xhr.responseType = "json";
      // notas['tipo_doc'] = this.component.name.toLowerCase();
      // xhr.send(JSON.stringify(notas));
    },
    activeGlobalLoader: function() {
      const appDom = document.querySelector("#app");
      const icon = document.querySelector("#app main +i.c_custom-loader");
      const body = document.querySelector("body");
      const html = document.querySelector("html");
      body.classList.add("loading_global");
      html.classList.add("loading_global");

      appDom.classList.add("loading_global");
      icon.classList.add("loading_global");
    },
    desactiveGlobalLoader: function() {
      const appDom = document.querySelector("#app");
      const icon = document.querySelector("#app main +i.c_custom-loader");
      const body = document.querySelector("body");
      const html = document.querySelector("html");
      body.classList.remove("loading_global");
      html.classList.remove("loading_global");
      appDom.classList.remove("loading_global");
      icon.classList.remove("loading_global");
    }
  }
};
</script>

<style>
</style>





// WEBPACK FOOTER //
// src/components/dataTable/commonTable/actionsHeader/btnDownload/BtnDownload.vue